import { t } from 'i18next';
import styles from './EmployerPortalJobs.module.css';
export const candidateUI = (item,jobs) => {
     return (
        <div className={`${styles.rowCenter} ${styles.candidates}`}>
            <div>
                <p className={styles.candidateText}>{t('filterButtons.all')}</p>
                <p className={`${styles.candidateCount} ${styles.candidateText}`}>({item.applications_count})</p>
            </div>
            <div className={styles.divider} />
            <div>
                <p className={styles.candidateText}>{t('general.applications.new')}</p>
                <p className={`${styles.candidateCount} ${styles.candidateText}`}>({item.new_applications_count })</p>
            </div>
        </div>
    );
};
